import React, {Component} from 'react';
import {Input, Checkbox, Form} from "antd";
import './media_role_edit.css';
import request from "../../base/request";

const {TextArea} = Input;


class MediaRoleEdit extends Component {

    constructor(props) {
        super(props);
        this.state = {
            roleName: "",
            roleCode: "",
            roleDescribe: "",
            mediaLimitsList: [],
            mediaIds: []
        }
        this.initData();
    }


    initData() {
        getAllMedia({}, (data) => {
            if (data) {
                data.length && data.forEach(i => {
                    let mediaLimitsList = [];
                    i.mediaList.length && i.mediaList.forEach(item => {
                        mediaLimitsList.push({label: item.name, value: item.id})
                    })
                    i.mediaList = mediaLimitsList;
                })
                this.setState({
                    mediaLimitsList: data
                });
                if (this.props.mediaRoleId) {
                    getMediaRoleById({mediaRoleId: this.props.mediaRoleId}, (res) => {
                        if (res) {
                            this.setState({
                                roleName: res.name,
                                roleCode: res.code,
                                describe: res.describe,
                                mediaIds: res.mediaIds
                            })
                        }
                    })
                }
            }
        });
    }

    render() {
        const {getFieldDecorator} = this.props.form;
        return (
            <div style={{marginBottom:"-15px"}}>
                <Form labelCol={{span: 4}} wrapperCol={{span: 19}}>
                    <Form.Item label="角色名称">
                        {getFieldDecorator('roleName', {
                            initialValue: this.state.roleName,
                            rules: [{required: true, message: '请输入角色名称'}],
                        })(<Input placeholder="请输入角色名称" maxLength={20}/>)}
                    </Form.Item>

                    <Form.Item label="角色编码">
                        {getFieldDecorator('roleCode', {
                            initialValue: this.state.roleCode,
                            rules: [{required: true, pattern:/^[0-9a-zA-Z:_]{1,100}$/, message: '角色编码只可填写字母、数字、下划线及冒号，限制输入100个字符'}],
                        })(<Input placeholder="请输入角色编码" maxLength={20}/>)}
                    </Form.Item>

                    <Form.Item label="角色描述" style={{marginTop: '3px'}}>
                        {getFieldDecorator('roleDescribe', {
                            initialValue: this.state.describe,
                            rules: [],
                        })(<TextArea placeholder="请输入描述信息，限制输入200个字符" style={{resize:"none"}} autoSize={{ minRows: 7, maxRows: 7 }} maxLength={200}/>)}
                    </Form.Item>

                    <Form.Item label="媒体权限">
                        <div style={{overflowY: "auto", maxHeight: '200px', width: '100%'}}>
                            {this.state.mediaLimitsList && this.state.mediaLimitsList.length > 0 && this.state.mediaLimitsList.map((item, index) => {
                                return (
                                    <div key={index}>
                                        <label>{item.mediaTypeName}</label>
                                        {getFieldDecorator(item.mediaTypeCode, {
                                            initialValue: this.getInitValue(item),
                                            rules: [],
                                        })(
                                            <Checkbox.Group style={{width: '100%'}} options={item.mediaList}/>)}
                                    </div>
                                )
                            })}
                        </div>
                    </Form.Item>
                </Form>
            </div>
        );
    }

    getInitValue(item) {
        let arr = [];
        item.mediaList.forEach(i=>{
            if(this.state.mediaIds.indexOf(i.value) > -1){
                arr.push(i.value);
            }
        })
        return arr;
    }
}

export const MediaRoleEditForm = Form.create({name: 'form_in_modal'})(MediaRoleEdit);

export const host = "/cm-sites-pms/";
export const Apis = {
    getAllMedia: host + 'media/getMediaGroupByType',
    getMediaRoleById: host + 'mediaRole/getById',
};

export const getAllMedia = (body, callBack) => {
    request({url: Apis.getAllMedia, body, callBack});
};

export const getMediaRoleById = (body, callBack) => {
    request({url: Apis.getMediaRoleById, body, callBack});
};